module.exports = __webpack_public_path__ + "media/components/assets/icons/arrow_r_white-bd92e5790b70c1ad24d376505b06fb35.png";